<template>
    <div class="m_container">
        <Header :title="tougaoInfo.title" />
        <section class="m_section">
            <!-- 轮播图 -->
            <swiper
                v-if="bannerList.length > 0"
                ref="mySwiper"
                :options="swiperOption"
                class="my-swipe"
            >
                <swiper-slide
                    v-for="item in bannerList"
                    :key="item.id"
                    class="swiper-item"
                >
                    <img
                        class="swiper-img"
                        :src="item.image_url"
                        alt=""
                    >
                </swiper-slide>
                <div
                    slot="pagination"
                    class="swiper-pagination"
                />
            </swiper>
            <!-- 内容 -->
            <div
                class="con_html_wrap"
                style="margin:20px;font-size: 15px;"
                v-html="tougaoInfo.content"
            />
        </section>
        <TabBar :current-tab="currentTab" />
    </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import { getTid, setTid } from '@/utils/cookies'
import { tougaoBanners } from '@/api/Tougaos'
import { mapGetters } from 'vuex'

export default {
    name: 'HomeTouGao',
    components: { Header, TabBar },
    data() {
        return {
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            currentTab: 'homeTougao',
            articleList: [],
            swiperOption: {
                pagination: '.swiper-pagination', // 参数选项,显示小点
                loop: true, // 循环
                autoplay: 2000, // 每张播放时长3秒，自动播放
                speed: 1000 // 滑动速度
            }
        }
    },

    computed: {
        ...mapGetters(['tougaoInfo', 'bannerList'])
    },

    created() {
        this.tid ? setTid(this.tid) : ''
    },

    methods: {
        getBanner() {
            tougaoBanners({ id: 1 }).then(res => {
                if (res.code === 200) {
                    this.banners = res.data
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
/deep/ img {
    max-width: 100%;
    height: auto;
}
.m_container {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .m_section {
        background: #fff;

        .my-swipe {
            overflow: hidden;
            width: 100%;
            height: 200px;
            background: #f5f5f5;

            /deep/ .swiper-item {
                width: 100%;
                height: 200px;
                display: flex;
                justify-content: center;
                align-items: center;

                .swiper-img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .news_wrap {
            padding-top: 10px;
            background: #fff;

            .news_item {
                padding: 6px 16px;
                font-size: 14px;
                text-align: left;
                line-height: 24px;
                border-bottom: 1px solid #f5f5f5;
                color: #999;

                h3 {
                    color: #333;
                    font-size: 18px;
                    padding-bottom: 10px;
                }

                .description {
                    height: 48px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .tip {
                    text-align: right;
                    padding: 8px 0;
                    color: red;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
